export var SDK_VERSION = '6.9.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/esm/version.js
// module id = 314
// module chunks = 1